export default function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
// module id = ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
// module chunks = 1